import React from "react";
import styles from "./CtaBtns.module.css";
const CtaBtns = ({ children, onAtion, icon, iconWhere, disabled }) => {
  return (
    <div
      className={`${disabled && styles.disabled} ${styles.btn} ${
        icon && styles.spaceadder
      } ${iconWhere === "left" && styles.leftIcon}`}
      onClick={() => onAtion()}
    >
      {icon ? (
        <>
          <i className={icon}></i>
          <div className={styles.containonbtn}>{children}</div>
        </>
      ) : (
        children
      )}
    </div>
  );
};

export default CtaBtns;
